import { useEffect } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { DeprecationPage } from "pages/DeprecationPage";
import { useFirewall } from "hooks/useFirewall";

const Routes = () => {
  const { NoticeElement, isRestricted, loading } = useFirewall();
  if (!loading && isRestricted) {
    return NoticeElement;
  }

  return <Route path="*" component={DeprecationPage} />;
};

type AppProps = {
  hideLoader: () => void;
};

const App = ({ hideLoader }: AppProps) => {
  useEffect(hideLoader, [hideLoader]);

  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};

export default App;
